import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation(); 

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const emailFromURL = params.get('email');
        if (emailFromURL) {
            setEmail(emailFromURL); 
        }
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            return setMessage('Passwords do not match.');
        }
    
        setLoading(true);
        try {
            const response = await axios.post('https://api.lbnhyderabad.com/login/reset-password', {
                email,
                newPassword,
            });
            setMessage(response.data.message);
            navigate('/login');

        } catch (error) {
            if (error.response) {
                setMessage('Error: ' + error.response.data.message);
            } else if (error.request) {
                setMessage('No response from server. Please try again later.');
            } else {
                setMessage('Error: ' + error.message);
            }
        }
        setLoading(false);
    };

    const inputStyle = {
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        boxSizing: 'border-box',
        fontSize: '14px',
        outline: 'none',
    };

    const inputFocusStyle = {
        ...inputStyle,
        borderColor: '#007bff',
        boxShadow: '0 0 5px rgba(0, 123, 255, 0.5)',
    };

    const buttonStyle = {
        width: '100%',
        padding: '10px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        cursor: 'pointer',
    };

    const buttonDisabledStyle = {
        ...buttonStyle,
        backgroundColor: '#cccccc',
        cursor: 'not-allowed',
    };

    return (
        <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto', padding: '20px', boxSizing: 'border-box', borderRadius: '8px', backgroundColor: '#f9f9f9', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Reset Password</h2>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                    <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Email:</label>
                    <input
                        type="email"
                        value={email}
                        readOnly
                        required
                        style={inputStyle}
                        onFocus={(e) => e.target.style = inputFocusStyle} // Focus style
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>New Password:</label>
                    <input
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        style={inputStyle}
                        onFocus={(e) => e.target.style = inputFocusStyle} // Focus style
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Confirm Password:</label>
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        style={inputStyle}
                        onFocus={(e) => e.target.style = inputFocusStyle} // Focus style
                    />
                </div>
                <button type="submit" disabled={loading} style={loading ? buttonDisabledStyle : buttonStyle}>
                    {loading ? 'Processing...' : 'Reset Password'}
                </button>
            </form>
            {message && <p style={{ textAlign: 'center', marginTop: '20px', color: 'red' }}>{message}</p>}
        </div>
    );
};

export default ResetPassword;
